/**
 * PageContent Component
 *
 * Standardized page content wrapper with:
 * - Consistent spacing
 * - Optional max width
 * - Padding and layout
 */

import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface PageContentProps {
  children: ReactNode
  className?: string
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
}

const maxWidthClasses = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
  full: 'max-w-full',
}

export function PageContent({ children, className, maxWidth = 'full' }: PageContentProps) {
  return (
    <div className={cn('mx-auto w-full', maxWidthClasses[maxWidth], className)}>
      {children}
    </div>
  )
}
